module.exports = __webpack_public_path__ + "img/layers.a1adba89.svg";